import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-centered-menu-btn',
    templateUrl: './centered-menu-btn.component.html',
    styleUrls: ['./centered-menu-btn.component.scss'],
    standalone: false
})
export class CenteredMenuBtnComponent implements OnInit {
  @Input() btnName: string = 'nombre';
  @Input() btnClass: string = 'btn';
  @Input() spanClass: string = 'intro-subtitel';
  @Input() btnIcon: string = 'inp-btn';
  @Input() btnLink: string = '/intro';
  @Input() isdisabled: boolean = false;
  
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

}
